import React from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import {
  Body,
  Children,
  CurveHolder,
  MainHolder,
} from "../../../components/common/basic";
import { Box, StyledText, BackButton } from "../../../components/common";
import { Curve } from "../../../components/svgs";
import useReferrals from "./hooks/useReferrals";

const PointRedemption = () => {
  const history = useHistory();
  const { referralsRewardItems, referralPoints } = useReferrals();

  return (
    <MainHolder style={{ background: "#F2F2F2" }}>
      <Children>
        <Header background={"#E31C79"}>
          <BackButton
            onClick={() => {
              history.goBack();
            }}
          />
          <div style={{ textAlign: "center", marginBottom: "30px" }}>
            <StyledText
              style={{ fontFamily: "MTNRegular" }}
              size={24}
              margin='0'
              color='white'
            >
              Redeem Points
            </StyledText>
          </div>

        </Header>
        <CurveHolder style={{ zIndex: 1, position: "relative" }}>
          <Curve fill={"#F2F2F2"} />
        </CurveHolder>
        <Box
          style={{
            display: "flex",
            backgroundColor: "transparent",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <RewardedCard value={referralPoints} label={"Referral points"} />
        </Box>
        <Body backgroundColor={"#F2F2F2"}>
          <Rewards
            items={referralsRewardItems}
            background={"white"}
            handleItemClick={(id) => {
              history.push('/referral/referralreward', { id })
            }}
          />
        </Body>
      </Children>
    </MainHolder>
  );
};

export default PointRedemption;

const Rewards = ({ items, background, handleItemClick }) => {
  return (
    <RewardWrapper>
      <StyledText
        size={20}
        style={{ fontFamily: "MTNMedium", margin: "0 0 20px 0" }}
      >{`Rewards to redeem`}</StyledText>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          justifyItems: "center",
        }}
      >
        {items.map((item) => (
          <RewardItem
            handleItemClick={handleItemClick}
            {...item}
            key={item.name}
            background={background}
            showValue={false}
          />
        ))}
      </div>
    </RewardWrapper>
  );
};

const RewardedCard = ({ value, label }) => (
  <Box
    style={{
      backgroundColor: "white",
      borderRadius: 10,
      height: 80,
      width: 200,
      margin: 10,
      marginTop: -60,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "2px 2px #E5E5E5",
      alignSelf: "center",
      zIndex: 6,
    }}
  >
    <StyledText style={{ margin: 0, fontSize: 30, color: "#E31C79" }}>
      {value}
    </StyledText>
    <StyledText style={{ margin: 0, fontFamily: "MTNRegular", fontSize: 14 }}>
      {label}
    </StyledText>
  </Box>
);

const RewardItem = ({
  imageUrl: image,
  name,
  code: id,
  points,
  value,
  handleItemClick,
  showValue = true,
  tag
}) => {
  const yellow = "#FFCD00";
  return (
    <div
      onClick={() => handleItemClick(id)}
      style={{
        width: "180px",
        maxWidth: "48%",
        background: yellow,
        borderRadius: "10px",
        overflow: "hidden",
        paddingBottom: "0px",
        marginBottom: "20px",
        position: "relative",
        height: 220,
      }}
    >
      <div>
        <img style={{ width: "100%" }} src={`${image}`} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "white",
          position: "absolute",
          bottom: 0,
        }}
      >
        <CurveHolder
          style={{ zIndex: 1, position: "relative", margin: "-20px 0px 0px" }}
        >
          <Curve height={24} fill={"white"} />
        </CurveHolder>
        <div
          style={{
            display: "flex",
            padding: "0 10px 0px 10px",
            justifyContent: "center",
          }}
        >
          <StyledText size={16} style={{ margin: 0 }}>
            {name}
          </StyledText>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            justifyItems: "center",
            padding: 10,
          }}
        >
          {
            showValue &&
            <>
              <StyledText
                color={"#000"}
                style={{ margin: 0, textDecoration: "line-through" }}
                size={10}
              >
                GHS {value}
              </StyledText>
              <div
                style={{
                  height: 15,
                  width: 1,
                  backgroundColor: "black",
                  margin: 5,
                  marginTop: 0,
                }}
              />
            </>
          }
          <StyledText color={"#E31C79"} style={{ margin: 0 }} size={10}>
            {`${points} points`}
          </StyledText>
        </div>
      </div>
    </div>
  );
};

const RewardWrapper = styled.div`
  margin-bottom: 30px;
`;

const Header = styled.div`
  overflow: hidden;
  padding: 20px 20px 80px 20px;
  background-color: ${({ background }) => background};
  position: relative;
  background-size: cover;
`;
